import { Intercom } from "@foundation/intercom-client";
import { personalizationClient } from "~config/personalizationClient";
import { userApiClient } from "~config/userApiClient";

const NEXT_PUBLIC_INTERCOM_BASE_URL =
  process.env.NEXT_PUBLIC_INTERCOM_BASE_URL ?? "";

/* WARNING: This mapping creates a cross-application dependency.
 * Client side calls will be calling API's from Lightsaber and Lineup
 * application which we do not maintain/control
 *
 * TODO: Consider moving common API endpoints to a shared endpoint or re-write locally */

const intercom = Intercom.init({
  apiEndpoints: {
    getImages: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/lineup-next/api/daper/images`,
    getNewsletters: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/lineup-next/api/daper/newsletters`,
    getNiCodeStories: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/lineup-next/api/content-service/stories/ni`,
    getPersonById: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/lineup-next/api/daper/people/id`,
    getSecurities: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/lineup-next/api/daper/securities`,
    getStories: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/article/api/daper/stories`,
    getStoryById: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/lineup-next/api/daper/stories/id`,
    getStoryBySlug: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/lineup-next/api/daper/stories/slug`,
    getImagesBulk: `${NEXT_PUBLIC_INTERCOM_BASE_URL}/article/api/daper/images`,
  },
});

intercom.personalizationClient = personalizationClient;
intercom.userApiClient = userApiClient;

export default intercom;
